import { render, staticRenderFns } from "./UserRelation.vue?vue&type=template&id=777dac2a&scoped=true"
import script from "./UserRelation.vue?vue&type=script&lang=js"
export * from "./UserRelation.vue?vue&type=script&lang=js"
import style0 from "./UserRelation.vue?vue&type=style&index=0&id=777dac2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777dac2a",
  null
  
)

export default component.exports